import React from "react";
import { useTranslation } from "react-i18next";
import { DrawerHeader } from "./notificationPanel";
import { SFStack } from "../grid";
import { SFNotificationIcon } from "../icons";
import SFTypography from "../typography";
import SFIconButton from "../button/iconButton";
import { SFCloseIcon } from "../icons";

export const PopupTitle = (props) => {
  const { t } = useTranslation();
  return (
    <DrawerHeader>
      <SFStack justifyContent="flex-start" alignItems="center" direction="row">
        <SFNotificationIcon color="grey500" />
        <SFTypography variant="cardSectionHeading" noWrap sx={{ ml: "15px" }}>
          {t("components.header.notificationPanel.title", {
            count: props.notifications.length,
          })}
        </SFTypography>
      </SFStack>
      <SFIconButton
        onClick={props.onClose}
        size="small"
        sx={(theme) => ({
          backgroundColor: theme.palette.grey100.main,
          borderRadius: "50%",
        })}
        ariaLabel={t("components.header.notificationPanel.closeButton")}
      >
        <SFCloseIcon color="grey500" size="small" />
      </SFIconButton>
    </DrawerHeader>
  );
};